import BirdAvatar from './BirdAvatar';
import { GENDER_ICON_FEMALE, GENDER_ICON_MALE } from '../../utils/genderDisplay';
import { Bird } from '../../api/birds';

interface BreedingPairAvatarsProps {
  maleBird?: Bird;
  femaleBird?: Bird;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  showBandIds?: boolean;
  bandIdPosition?: 'below' | 'overlay';
  layout?: 'horizontal' | 'stacked';
  className?: string;
}

export default function BreedingPairAvatars({
  maleBird,
  femaleBird,
  size = 'md',
  showBandIds = false,
  bandIdPosition = 'below',
  layout = 'horizontal',
  className = '',
}: BreedingPairAvatarsProps) {
  const containerClass = layout === 'horizontal' 
    ? 'flex items-center space-x-2' 
    : 'flex flex-col items-center space-y-2';

  return (
    <div className={`${containerClass} ${className}`}>
      {/* Male Bird */}
      <div className="relative">
        <BirdAvatar
          bird={maleBird}
          size={size}
          shape="rounded"
          showBandId={showBandIds}
          bandIdPosition={bandIdPosition}
        />
        {maleBird && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-cyan-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">{GENDER_ICON_MALE}</span>
          </div>
        )}
      </div>

      {/* Connecting Symbol */}
      {layout === 'horizontal' && (
        <div className="flex items-center">
          <span className="text-slate-400 text-lg font-semibold">×</span>
        </div>
      )}

      {/* Female Bird */}
      <div className="relative">
        <BirdAvatar
          bird={femaleBird}
          size={size}
          shape="rounded"
          showBandId={showBandIds}
          bandIdPosition={bandIdPosition}
        />
        {femaleBird && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-pink-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">{GENDER_ICON_FEMALE}</span>
          </div>
        )}
      </div>
    </div>
  );
} 